import Link from "next/link"
import tw from "twin.macro"
import slugify from "slugify"
import { useRouter } from "next/router"
import { useCTX } from "../../util/context"

export enum AllFilters {
  Paintings = "Paintings",
  Overview = "Overview",
  WorksonPaper = "Works on Paper",
  Sculpture = "Sculpture",
  Photographs = "Photographs",
}

interface NavItemProps {
  view: AllFilters
}

const NavItem = (props: WorksNavProps & NavItemProps) => {
  const { view, worksNav } = props
  const slug = slugify(view, { replacement: "-", lower: true })
  const pathname = slug == "overview" ? `/works/` : `/works/${slug}/`
  const active = worksNav && slugify(worksNav, { replacement: "", lower: true })
  const router = useRouter()
  const { workctx, setWorkCtx } = useCTX()

  const handleClick = async (e: React.MouseEvent, slug: string) => {
    // e.preventDefault()
    setWorkCtx(slug)
    await router.push(
      {
        pathname: pathname,
      },
      undefined,
      { shallow: true },
    )
  }

  return (
    <li css="letter-spacing: 0.1em;">
      <Link
        href={pathname}
        passHref
        tw="no-underline transition delay-200 hover:(no-underline border-b border-rpd-gray-8)"
        css={active == slug ? tw`border-b border-rpd-gray-8` : tw``}
        onClick={(e: React.MouseEvent) => handleClick(e, slug)}
      >
        {view}
      </Link>
    </li>
  )
}

interface WorksNavProps {
  worksNav?: string
}
const WorksNav = (props: WorksNavProps) => {
  return (
    <ul tw="px-2 flex flex-col space-y-2 font-sans text-xs uppercase tablet:(flex-row space-x-4 space-y-0)">
      <NavItem view={AllFilters.Overview} {...props} />
      <NavItem view={AllFilters.Paintings} {...props} />
      <NavItem view={AllFilters.WorksonPaper} {...props} />
      <NavItem view={AllFilters.Sculpture} {...props} />
      <NavItem view={AllFilters.Photographs} {...props} />
    </ul>
  )
}
export default WorksNav
